// Format central des filtres transmis du Copilote vers les modules du Tableau de bord.
// URL : /vendor/pilotage?tab=bookings&payment=unpaid&from=2026-07-01&to=2026-07-31&mode=junago
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const PAYMENT_KEYS = ["unpaid", "partial", "paid", "overdue"];
export const PAYMENT_LABELS = {
  unpaid: "Impayées",
  partial: "Partiellement payées",
  paid: "Payées",
  overdue: "En retard de paiement",
};

export function parseDashboardFilters(searchParams, { statuses = [] } = {}) {
  const out = {};
  const s = searchParams.get("status");
  if (s && statuses.includes(s)) out.status = s;
  const p = searchParams.get("payment");
  if (p && PAYMENT_KEYS.includes(p)) out.payment = p;
  const f = searchParams.get("from");
  if (f && DATE_RE.test(f)) out.from = f;
  const t = searchParams.get("to");
  if (t && DATE_RE.test(t)) out.to = t;
  const q = searchParams.get("q");
  if (q && q.trim()) out.q = q.trim().slice(0, 60);
  return out;
}

// Applique un patch de filtres à l'URL sans toucher aux autres paramètres (tab, mode…)
export function syncFiltersToUrl(searchParams, setSearchParams, patch) {
  const next = new URLSearchParams(searchParams);
  Object.entries(patch).forEach(([k, v]) => {
    if (v && v !== "all") next.set(k, v);
    else next.delete(k);
  });
  setSearchParams(next, { replace: true });
}
